(() => {
  const mobileProductLayout = window.matchMedia('(max-width: 576px)')

  const findLazyBlock = (root, selector) => {
    const rendered = root.querySelector(selector)
    if (rendered) return rendered.closest('lazy-section-template') || rendered

    for (const lazyBlock of root.querySelectorAll('lazy-section-template')) {
      const template = lazyBlock.querySelector('template')
      if (template && template.content.querySelector(selector)) return lazyBlock
    }

    return null
  }

  const arrangeProduct = (productInfo) => {
    const quote = productInfo.querySelector('.product__popup')
    const publicPriceRow = productInfo.querySelector('[data-mpsb-public-price-row]')
    const personalizedPriceBlock = productInfo.querySelector('.shopify-app-block:has(.mpsb-personalized-price)')
    const usesPersonalizedPrice = document.body.classList.contains('mpsb-price-role-pro') || document.body.classList.contains('mpsb-price-role-retail')
    const mediaExtras = productInfo.querySelector('[data-mpsb-product-media-extras]')
    const tabs = findLazyBlock(productInfo, '.product__tabs')

    if (tabs && mobileProductLayout.matches) {
      const mainInfoGroup = findLazyBlock(productInfo, '.product__main-info-group')
      const personalizedPriceAnchor = personalizedPriceBlock || productInfo.querySelector('.product__info-container > .shopify-app-block')
      const descriptionAnchor = usesPersonalizedPrice && personalizedPriceAnchor ? personalizedPriceAnchor : mainInfoGroup

      if (descriptionAnchor && descriptionAnchor.nextElementSibling !== tabs) descriptionAnchor.after(tabs)
    } else if (tabs && mediaExtras && tabs.parentElement !== mediaExtras) {
      mediaExtras.append(tabs)
    }

    const actionsGroup = findLazyBlock(productInfo, '.product__actions-group')
    const securityBadges = findLazyBlock(productInfo, '.product__security-badges')
    if (actionsGroup && securityBadges && actionsGroup.nextElementSibling !== securityBadges) {
      actionsGroup.after(securityBadges)
    }

    if (quote && usesPersonalizedPrice && personalizedPriceBlock && quote.parentElement !== personalizedPriceBlock) {
      personalizedPriceBlock.append(quote)
    } else if (quote && !usesPersonalizedPrice && publicPriceRow && quote.parentElement !== publicPriceRow) {
      publicPriceRow.append(quote)
    }
  }

  const arrangeAllProducts = () => {
    document.querySelectorAll('product-info.mpsb-product-premium').forEach(arrangeProduct)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrangeAllProducts)
  } else {
    arrangeAllProducts()
  }

  new MutationObserver(arrangeAllProducts).observe(document.body, {
    attributes: true,
    attributeFilter: ['class']
  })

  if (typeof mobileProductLayout.addEventListener === 'function') {
    mobileProductLayout.addEventListener('change', arrangeAllProducts)
  } else {
    mobileProductLayout.addListener(arrangeAllProducts)
  }

  document.addEventListener('shopify:section:load', arrangeAllProducts)
})()
